import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import {ButtonAppBar} from './components';
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux';


// css import
import './App.css';

// pages import
import { Domaine, Home, Resultats, Informations, Fonctionnement, Apropos, Contact } from './pages';
import { persistor, store } from './state/store/store';

function App() {

  return (
		<Provider store={store} >
			<PersistGate persistor={persistor}>
				<Router>
					<div className='App'>
						<ButtonAppBar />
						<div className='Container'>
							<Switch>
								<Route path='/' exact component={Home} />
								<Route path='/infos' component={Informations} />
								<Route path='/domaine' exact>
									<Redirect to='/domaine/1/1/1/1.a' />
								</Route>
								<Route path='/domaine/:dom/:rel/:ref/:cr' component={Domaine} />
								<Route path='/resultats' component={Resultats} />
								<Route path='/fonctionnement' component={Fonctionnement} />
								<Route path='/apropos' component={Apropos} />
								<Route path='/contact' component={Contact} />		
							</Switch>				
						</div>
					</div>
				</Router>
			</PersistGate>
		</Provider>
	)
}

export default App;
